import { OffersPromoRepository } from "../../Repository/OffersPromoRepository";

export interface UpdateStatePromoBarUseCase {
    invoke: (promoBarId: number) => Promise<boolean>;
  }
  
  export class UpdateStatePromoBar implements UpdateStatePromoBarUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(promoBarId: number){
       
        if(promoBarId <= 0){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateStatePromoBar(promoBarId);
        return update;
    }
  }